import React, {Component} from 'react';
import TextTruncate from 'react-text-truncate';
import LocalizedStrings from '../../localization/strings';

import { Editor } from '@tinymce/tinymce-react';


// TinyMCE so the global var exists
// eslint-disable-next-line no-unused-vars
import tinymce from 'tinymce/tinymce';

// Theme
import 'tinymce/themes/silver';
// Toolbar icons
import 'tinymce/icons/default';
// Editor styles
import 'tinymce/skins/ui/oxide/skin.min.css';

// importing the plugin js.
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/hr';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/spellchecker';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/wordcount';
import 'tinymce/plugins/code';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/media';
import 'tinymce/plugins/nonbreaking';
import 'tinymce/plugins/table';
import 'tinymce/plugins/template';
import 'tinymce/plugins/help';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/print';


const strip = (html) => {
    var tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
}


export default class TextField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editing: false
        };
    }

    render() {

        let {value} = this.props;
        if (this.state.editing) {
          return (
            <Editor
              value={this.props.value}
              onEditorChange={(value)=>{
                this.props.onChange(value);
              }}
              init={{
                height: 500,
                menubar: true,
                extended_valid_elements: 'script[src|type],div[class|data-embed-type|data-embed-id|data-style|data-map-hash|data-from-embed]',
                valid_children: '+body[script]',
                valid_elements: '*[*]',  // allows all elements and attributes
                forced_root_block: false,
                force_br_newlines: true,
                force_p_newlines: false,

                paste_filter_drop: true,
                paste_remove_styles: true,
                paste_remove_spans: true,
                paste_webkit_styles: 'none', // prevents WebKit from preserving styles
                content_style: '.strava-embed-placeholder { background-color: #cbd5dd; border: 1px solid grey;  display: inline-block; width: 100%; pointer-events: none; cursor: default;  } .strava-embed-placeholder::before {content: "Strava embed";}',
                plugins: [
                  'advlist autolink lists link image charmap print preview anchor',
                  'searchreplace visualblocks code fullscreen',
                  'insertdatetime media table paste code help wordcount'
                ],
                toolbar: 'undo redo | formatselect | ' +
                  'bold italic backcolor | alignleft aligncenter ' +
                  'alignright alignjustify | bullist numlist outdent indent | ' +
                  'removeformat | table | paste pastetext | code'
              }}
            />
          );
        } else {
            return (
                <div className="text-field">
                    <a className="btn" onClick={() => {
                        this.setState({editing: true})
                    }}>{LocalizedStrings.edit}</a>
                    <TextTruncate line={10} truncateText="…" text={strip(value)}/>

                </div>
            )
        }

    }
}



// WEBPACK FOOTER //
// ./src/js/components/form/text-field.js